/* eslint-disable no-param-reassign */
import angular from 'angular';

angular
  .module('myConsultApp')
  // Phone Numebr Formatting and Validation
  .directive('phoneNumber', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, elem, attrs, ngModelController) => {
        var formatCountryCode = (value) => {
          if (typeof value === 'undefined' || value === '' || value == null) return value;
          const valueWithOutCountryCode = value
            .toString()
            .replace(/[^\d.]*/g, '') // remove all non digits
            .replace(/^1/, '') // remove leading 1
            .substring(0, 10); // limit to 10 digits
          if (valueWithOutCountryCode) {
            return '+1' + valueWithOutCountryCode; // add country code
          }
          return value;
        };
        ngModelController.$viewChangeListeners.push(function handleNgModelChange() {
          ngModelController.$setViewValue(formatCountryCode(ngModelController.$viewValue));
          ngModelController.$render();
        });
      },
    };
  })
  // Zip Code Formatting and Validation
  .directive('zipCode', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elem, attrs, ngModel) {
        var fixDash = function (val) {
          if (typeof val == typeof undefined) return val;

          var parsedVal = val
            .toString()
            .replace(/-/g, '')
            .replace(/\s/g, '')
            .replace(/[^\d\.]*/g, '')
            .substring(0, 9);
          if (parsedVal.length > 5) parsedVal = parsedVal.replace(/(.{5})/g, '$1-').trim();
          return parsedVal;
        };

        var parseZipCode = function (val) {
          var viewVal = fixDash(val);
          ngModel.$viewValue = viewVal;
          ngModel.$render();
          return ngModel.$viewValue;
        };

        var formatZipCode = function (val) {
          if (val && val.length > 0) {
            var modelValue = fixDash(val);
            ngModel.$modelValue = modelValue;
          }
          return ngModel.$modelValue;
        };

        ngModel.$parsers.push(parseZipCode);
        ngModel.$formatters.push(formatZipCode);
      },
    };
  })

  // Email validate on blur
  .directive('emailValidate', function () {
    var EMAIL_REGX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elm, attr, ctrl) {
        elm.bind('blur', function () {
          scope.$apply(function () {
            if (elm.val() == '' || elm.val() == null) {
              ctrl.$setValidity('email', true);
            } else if (EMAIL_REGX.test(elm.val())) {
              ctrl.$setValidity('email', true);
            } else {
              ctrl.$setValidity('email', false);
            }
          });
        });
        elm.bind('focus', function () {
          scope.$apply(function () {
            ctrl.$setValidity('email', true);
          });
        });
      },
    };
  });
